<template>
<m-pageframe
    :title="title"
>
<v-container
    v-if="start_data != null"
>
    <v-card
        style="margin-bottom: 15px;"
    >
        <v-card-title>CRM Settings</v-card-title>
        <v-card-text>
            <v-select
                label="CRM System"
                :items="crm_types"
                v-model="crm_value"
                return-object
            />

            <v-text-field
                label="Send To (CRM ADF Email Adress)"
                v-model="send_to"
                hint="To specify multiple email addresses, separate with a semi-colon (;)"
                :rules="email_validation_rules"
                validate-on-blur
                data-lpignore="true"
                autocomplete="off"
            >
                <span
                    slot="append-outer"
                    v-if="$rc.$state.isSystemAdmin()"
                >
                    <m-restricted-button
                        v-on:click="showSysAdminInfo()"
                        icon
                        small
                    >
                        <v-icon>mdi-information-outline</v-icon>
                    </m-restricted-button>
                </span>
            </v-text-field>
        </v-card-text>
    </v-card>

    <v-card
        style="margin-bottom: 15px;"
    >
        <v-card-title>Lead</v-card-title>
        <v-card-text>
            <v-text-field
                label="Full Name"
                v-model="contact_full_name"
                data-lpignore="true"
                autocomplete="off"
            />

            <v-text-field
                label="First Name"
                v-model="contact_first_name"
                data-lpignore="true"
                autocomplete="off"
            />

            <v-text-field
                label="Last Name"
                v-model="contact_last_name"
                data-lpignore="true"
                autocomplete="off"
            />

            <v-text-field
                label="Phone"
                hint="Used for matching"
                v-model="contact_phone"
                data-lpignore="true"
                autocomplete="off"
            />

            <v-text-field
                label="Email"
                hint="Used for matching"
                v-model="contact_email"
                data-lpignore="true"
                autocomplete="off"
            />
        </v-card-text>

        <v-card-actions
        >
            <v-spacer/>
            <v-btn
                style="margin-right: 15px;"
                v-on:click="onCancel"
            >
                Cancel
            </v-btn>
            <v-btn
                color="primary"
                :disabled="!is_valid"
                v-on:click="onSend"
            >
                {{title}}
            </v-btn>
        </v-card-actions>
    </v-card>



    <div
        style="text-align: right"
    >

    </div>

    <m-adf-sys-admin-info-dialog
        ref="sys-admin-info"
    />

</v-container>
</m-pageframe>
</template>

<script>
const validate = require('@/js/validate.js');
const E164 = require('@/js/E164.js');

export default {
    data() {
        return {
            start_data: null,

            crm_types: [
                { 'text' : 'Reynolds & Reynolds', 'value' : 'reynolds-and-reynolds' },
                { 'text' : 'Generic', 'value' : 'generic' }
            ],

            crm_value: null,
            send_to: null,
            contact_full_name: null,
            contact_first_name: null,
            contact_last_name: null,
            contact_phone: null,
            contact_email: null,
        }
    },

    mounted () {

        let params = {
            'integration_id' : this.$route.params.integration_id,
            'conversation_id' : this.$route.params.conversation_id,
            'active_endpoint' : this.$route.params.active_endpoint,
        };

        this.$rc.showSpinner();
        this.$rc.getAdfStartData(
            params,

            (start_data) => {
                this.$rc.hideSpinner();

                this.crm_value = this.crm_types.find( x => x.value == start_data.system_type ) || null;
                this.send_to = start_data.send_to;
                this.contact_full_name = start_data.contact_full_name;
                this.contact_first_name = start_data.contact_first_name;
                this.contact_last_name = start_data.contact_last_name;
                this.contact_phone = E164.prettyPrintUsPhoneNumber(start_data.contact_phone);
                this.contact_email = start_data.contact_email;

                this.start_data = start_data;
            },

            () => {
                this.$rc.hideSpinner();
                this.$rc.alert('Error','Unable to complete API call');
            },
        );
    },

    methods: {
        onCancel()
        {
            let params = {
                'conversation_id' : this.$route.params.conversation_id,
                'endpoint' : this.$route.params.active_endpoint,
            };

            this.$router.push({
                'name': 'home-routed',
                'params' : params,
            }).catch(e=>{}); // swallow any exception
        },

        onSend()
        {
            this.$rc.confirm(
                'Confirm Client Profile',
                '<b>Warning</b>: Don\'t send information to your CRM unless it matches an existing profile. Doing so will create a new lead in your CRM that may not be assigned to you.<br/><br/>If necessary click cancel and edit the contact information to match the Client Profile in your CRM before sending.',
                [
                    {'text' : 'Cancel', 'value' : 'cancel' },
                    {'text' : 'Send', 'value' : 'confirmed' },
                ],

                (response) => {
                    if ( response != 'confirmed' ) return;

                    this.doSend();
                }
            );
        },

       doSend()
       {
           let params = {
               'integration_id' : this.start_data.integration_id,
               'system_type' : this.crm_value.value,
               'send_to' : this.send_to,
               'contact_full_name' : this.contact_full_name,
               'contact_first_name' : this.contact_first_name,
               'contact_last_name' : this.contact_last_name,
               'contact_phone' : E164.createEndpointFromUSPhoneNumber(this.contact_phone),
               'contact_email' : this.contact_email,
               'comments' : '[RedChirp Conversation] ' + this.start_data.public_conversation_url,
               'conversation_id' : this.$route.params.conversation_id,
               'active_endpoint' : this.$route.params.active_endpoint,
           };

           this.$rc.showSpinner();
           this.$rc.sendAdfLead(
               params,

               (data) => {
                   this.$rc.hideSpinner();
                   this.onCancel();
               },

               () => {
                   this.$rc.hideSpinner();
                   this.$rc.alert('Error','Unable to send conversation.');
               },
           );

       },

        showSysAdminInfo()
        {
            this.$refs['sys-admin-info'].showDialog();
        },
    },

    computed: {
        title() {
            if ( this.start_data == null ) return 'Send Auto-lead Data Format (ADF)';

            return "Send Conversation to "+this.start_data.system_label;
        },

        email_validation_rules()
        {
            return [validate.isEmailAddresses];
        },

        is_valid()
        {
            if ( this.crm_value == null ) return false;
            if ( !validate.isEmailAddresses(this.send_to) ) return false;

            let isBlank = (value) => { return value == null || value.trim().length == 0; }

            if ( isBlank(this.contact_full_name) ) return false;
            if ( isBlank(this.contact_first_name) ) return false;
            if ( isBlank(this.contact_last_name) ) return false;
            if ( isBlank(this.contact_phone) ) return false;
            if ( !validate.isUSPhoneNumber(this.contact_phone) ) return false;
            if ( !validate.isBlankOrEmailAddress(this.contact_email) ) return false;

            return true;
        }
    },
}
</script>

<style lang="scss" scoped>
</style>

